module.exports = __webpack_public_path__ + "static/img/k3.f3da6fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/k3.png
// module id = mnP5
// module chunks = 1